import React from "react";
import TooltipComponent from "@material-ui/core/Tooltip";
import { IconButton, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import InfoIcon from "../../Icons/InfoIcon";
import "./tooltip.css";

const useStyles = makeStyles(() => ({
  root: {
    alignItems: "start",
    margin: "0 !important",
    height: "12px !important",
     backgroundColor: "transparent !important", 
    '&:hover': {
      backgroundColor: "transparent !important", 
    },

  },
  
  tooltip: {
    maxWidth: "260px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075"
    },
    color: "white",
    fontSize: 15
  }
}));

function Tooltip({ tooltip, type, icon, iconVariant, direction, mandatoryIcon, customStyle,buttonStyle,customStyle1  }) {
  const classes = useStyles();
  const { t } = useTranslation(["styles", "translation"]);

  return (
    <div className="tooltipMain" title=""  style={{ ...buttonStyle, ...customStyle1 }}>
      {type === "1" 
      ? (
        <span className="toolTip_afb" title={tooltip}>
          <InfoIcon iconVariant={iconVariant} />
        </span>
      ) 
      : (
        <TooltipComponent
          title={tooltip}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          enterTouchDelay={0}
          arrow
        >
          <IconButton aria-label="tooltopIcon" classes={{ root: classes.root }}>
            <InfoIcon iconVariant={iconVariant} className="tooltipIcon" />
          </IconButton>
        </TooltipComponent>
      )}
    </div>
  );
}

export default Tooltip;
